const getAuthRoot = (state,) => state.auth

export const getTokenSelector = (state,) => getAuthRoot(state,).token
export const getAuthLoadingSelector = (state,) => getAuthRoot(state,).loading
export const getUserSelector = (state,) => getAuthRoot(state,).user || {}
